import React from "react";
import Description from "../components/description";
import "../styles.css";

const ShowVideo = (props) => {
  console.log(props.location.state)
  let url =
    "https://www.youtube.com/embed/" + window.location.pathname + "?autoplay=1";

    if (props.location.state===undefined)
    {return<><div className="videoPlayer">
    <iframe
      title={url}
      src={url}
      width="960"
      height="447"
      allow="autoplay"
      allowFullScreen
    ></iframe></div>
    </>
    }else{
  return (
  
      <div className="videoPlayer">
        <iframe
          title={url}
          src={url}
          width="960"
          height="447"
          allow="autoplay"
          allowFullScreen
        ></iframe>
      <Description value={props.location.state.info}/>

      </div>
  );
    }
};

export default ShowVideo;
